export const appUrl = "https://product-development.collabrix.co"; 
export const smlUrl = "https://product-development.collabrix.co"; 
export const AnalyticsKey = "UA-171452508-1";
export const CaptchaSiteKey = "6Legf8oZAAAAAOxXKdJX-eBfOoHk5ppgUhRkUwZm";
export const azureADClientID = "9816eb16-5bad-4a6d-bda6-3cb2af5bbc1a";
export const azureADTenantID = "ecfd6ff7-e355-401d-a64e-4e38f61f78cc";
export const adobeClientID = "7ea838bb450c4a488a7de2bea6ebd68f";
export const associateCMOsRoles = [8, 2, 31, 32, 19];
export const associateWarehouseRoles = [33];
export const pingClientID = "";
export const pingClientSecret = "";
export const pingOAuthUrl = "https://sso-qa.bms.com:443/auth/oauth2/authorize";
export const digitizationApiKey = "OStdJyfwQF1i6mlZ5T83D5yUxAfpug928LdZBQd4";
export const digitizationAWSDataApiUrl = "https://dxldxgjiec.execute-api.us-west-2.amazonaws.com/dev";
export const sponsorHelpUrlRedirect  = "";
export const raiseTicketUrlRedirect = "";
